import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import Synergy from '@/roc/wonders/base/Synergy';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import EraType from '@/roc/era/EraType';

const ForbiddenCity = {
  id: '48',
  name: 'Forbidden City',
  era: EraType.earlyRome,
  icon: 'forbidden',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.TEMPLE | WonderKind.PALACE,
  kindMultiplier: 1,
  owner: WonderOwner.CHINA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.CHINA_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        10,
        13,
        15,
        16.5,
        18,   // 5
        19.5,
        20.5,
        22.0,
        23.0,
        24.0, // 10
        24.5,
        25.5,
        26.5,
        27,
        28,   // 15
        28.5,
        29,
        30,
        30.5,
        31, // 20
        31.5,
        32.5,
        33,
        33.5,
        34,   // 25
        34.5,
        35,
        35.5,
        36,
        36.5  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        100,
        110,
        120,
        130,
        140,  // 5
        150,
        160,
        170,
        180,
        190,  // 10
        200,
        210,
        220,
        230,
        240,  // 15
        250,
        260,
        270,
        280,
        290,  // 20
        300,
        310,
        320,
        330,
        340,  // 25
        350,
        360,
        370,
        380,
        390,  // 30
      ]).withOutput(ProductionOutputType.ALL_CURRENT_ERA_GOODS),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(60).withKind(WonderKind.TEMPLE),
      effect: null,
    }
  ],
};

export default ForbiddenCity;
